"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.user.exceeded': 'Limite utenti raggiunto. Aggiorna il tuo piano per aggiungere più utenti.',
    'limits.user.limitReached': 'Limite utenti: {limit} (aggiorna per aggiungerne di più)',
};
